const StructuredContentDateType = {
  DOB: "dob",
  INTERACTION: "interaction",
  AUTOMATION_ANALYSIS_WINDOW: "automation_analysis_window",
  ALPHARUN_PLATFORM: "alpharun_platform",
  OTHER: "other"
};
const allStructuredContentDateTypes = [
  StructuredContentDateType.DOB,
  StructuredContentDateType.INTERACTION,
  StructuredContentDateType.AUTOMATION_ANALYSIS_WINDOW,
  StructuredContentDateType.ALPHARUN_PLATFORM,
  StructuredContentDateType.OTHER
];
export {
  StructuredContentDateType,
  allStructuredContentDateTypes
};
//# sourceMappingURL=types.js.map
